import React from 'react';
import { siteContent } from '../data/mock';

const Footer = () => {
  const { brand } = siteContent;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 border-t border-neutral-100">
      <div className="mx-auto max-w-6xl px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <img 
            src={brand.logo} 
            alt={brand.name} 
            className="h-6 w-auto opacity-60"
          />
          <span className="text-sm text-neutral-500">
            © {currentYear} {brand.name}
          </span>
        </div>
        <a 
          href={brand.loginUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-neutral-500 hover:text-neutral-700"
        >
          Login
        </a>
      </div>
    </footer>
  );
};

export default Footer;
